import { FormBuilder, Validators } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';
import { greaterThanZero } from '../validators/customValidators';
import { ThirdPartyCostPaidBy } from '../components/planner-edit/constants/ThirdPartyCostPaidBy.const';

export class AdditionalCostDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'cPMCost',
            type: 'number',
            validators: [greaterThanZero(false)]
        },
        {
            name: 'costTypeId',
            type: 'number',
            validators: [Validators.required]
        },
        {
            name: 'paidById',
            type: 'number',
            validators: [Validators.required],
            defaultValue: ThirdPartyCostPaidBy.Turn.id
        },
        {
            name: 'vendorId',
            type: 'number',
            validators: [Validators.required]
        }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
